import { getNextWrappingIndex } from './getNextWrappingIndex';
import { useCarousel } from './useCarousel';
import { usePreloadImages } from './usePreloadImages';

export const useImageCarousel = (imageURLs: string[], startingIx = 0, preloadCount = 0) => {
  const preloadArr = Array(preloadCount)
    .fill(null)
    .map((_, ix) => imageURLs[getNextWrappingIndex(startingIx + ix, imageURLs.length)]);
  usePreloadImages(preloadArr as string[]);

  return useCarousel(imageURLs, startingIx);
};
